import {
  Flex,
  IconInCircle,
  IconNames,
  Pane,
  sizes,
  spaces,
  Text,
  Divider,
} from '@electricjs/arc';

export const AssetDetailsBaseCard = ({
  title,
  children,
  icon,
}: {
  title: string;
  children: React.ReactNode;
  icon: IconNames;
}) => {
  const { space_m, space_l } = spaces;
  const { size_32 } = sizes;

  return (
    <Pane
      id="asset-details-card"
      elevated
      p={`${space_l} 0`}
      flexDirection="column">
      <Flex alignItems="center" mb={space_l} px={space_m} gap={space_m}>
        <IconInCircle
          icon={icon}
          intent="primary"
          size={size_32}
          iconSize="small"
        />
        <Text variant="heading-3">{title}</Text>
      </Flex>
      <Divider />
      {children}
    </Pane>
  );
};
